import { createAuth0 } from '@auth0/auth0-vue';

const auth0Client = createAuth0({
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  cacheLocation: 'localstorage',
  responseType: 'code',
  grantType: 'authorization_code',
  legacySameSiteCookie: false,
  cookieDomain: '.anthill.technology',
  authorizationParams: {
    redirect_uri: window.location.origin + '/callback',
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    scope: 'openid, profile, email, offline_access',
    grant_type: 'authorization_code',
    response_type: 'code',
  },
});

export default auth0Client;
